<h1 mat-dialog-title>Cambiar contraseña</h1>
<hr>
<mat-dialog-content>
    <p *ngIf="dialogRef.disableClose">Por seguridad, debes establecer una nueva contraseña antes de continuar.</p>
    <form [formGroup]="form" (ngSubmit)="guardar()">
        <div class="form-group">
            <label>Nueva contraseña</label>
            <input type="password" class="form-control" formControlName="password" placeholder="Nueva contraseña">
        </div>
        <div class="form-group">
            <label>Confirmar contraseña</label>
            <input type="password" class="form-control" formControlName="password_confirmation" placeholder="Confirmar contraseña">
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button *ngIf="!dialogRef.disableClose" class="m-1" (click)="dialogRef.close()">
        <i class="fa fa-times"></i> Cancelar
    </button>
    <button mat-raised-button color="primary" class="m-1" (click)="guardar()">
        <i class="fa fa-save"></i> Guardar
    </button>
</mat-dialog-actions>
